exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.initial-image[data-v-ffef685c] {\n    cursor: pointer;\n}\n.remove-icon[data-v-ffef685c] {\n    position: absolute;\n    top: 35%;\n    right: 0;\n    left: 0;\n    margin: auto;\n    cursor: pointer;\n}\n", ""]);

// exports
